import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createNewTest } from "../../../api/lead";

const NewExam = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    subject: "",
    duration: "",
    difficulty: "",
    classes_enabled: [],
    registration_start_date: "",
    start_time: "",
    end_time: "",
    content_type: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "classes_enabled") {
      // Convert comma-separated string to array
      setFormData((prev) => ({
        ...prev,
        [name]: value.split(",").map((v) => parseInt(v.trim())),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUpdate = async () => {
    // Check for empty/null values
    const {
      name,
      description,
      subject,
      duration,
      difficulty,
      classes_enabled,
      registration_start_date,
      start_time,
      end_time,
      content_type,
    } = formData;

    if (
      !name ||
      !description ||
      !subject ||
      !duration ||
      !difficulty ||
      !classes_enabled.length ||
      !registration_start_date ||
      !start_time ||
      !end_time ||
      !content_type
    ) {
      alert("Please fill in all the fields before submitting.");
      return;
    } else {
        const response = await createNewTest(formData);
        if (response.status === true) {
            alert(response.message)
            navigate("/home/exam")
        } else {
            alert(response.message)
        }
    }
  };

  return (
    <div className="container mt-4">
      {/* BACK BUTTON */}
      <div className="mb-4">
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <span className="mx-4 h5">Create New Exam</span>
      </div>
      <div className="row">
        <div className="col-7">
          <form>
            <div className="mb-3">
              <label className="form-label fw-semibold">Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="JEE Main Mock-1"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Description</label>
              <textarea
                className="form-control"
                name="description"
                rows="3"
                placeholder="Prepare Yourself For JEE Mains"
                value={formData.description}
                onChange={handleChange}
              />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Subject</label>
                <input
                  className="form-control"
                  name="subject"
                  placeholder="Maths, Science"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Duration</label>
                <input
                  className="form-control"
                  name="duration"
                  placeholder="45 Mins (Please mention in Minutes)"
                  value={formData.duration}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Difficulty</label>
                <input
                  className="form-control"
                  name="difficulty"
                  placeholder="Hard"
                  value={formData.difficulty}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">
                  Classes Enabled (comma separated)
                </label>
                <input
                  className="form-control"
                  name="classes_enabled"
                  placeholder="11, 12"
                  value={formData.classes_enabled.join(", ")}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold">
                  Registration Start
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="registration_start_date"
                  value={formData.registration_start_date}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold">Start Time</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="start_time"
                  value={formData.start_time}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold">End Time</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="end_time"
                  value={formData.end_time}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Content Type</label>
              <input
                className="form-control"
                name="content_type"
                placeholder="20 MCQs"
                value={formData.content_type}
                onChange={handleChange}
              />
            </div>

            <button
              type="button"
              className="btn primary-button text-white rounded-pill w-100 mt-3"
              onClick={handleUpdate}
            >
              Create Test
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewExam;
